import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","success","error"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[celebrity]/Gallery.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SubTypeFilter"] */ "/vercel/path0/src/app/[celebrity]/SubTypeFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoBackButton"] */ "/vercel/path0/src/components/GoBackButton/GoBackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscriptionBtn"] */ "/vercel/path0/src/components/SubscriptionBtn/SubscriptionBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryContainer"] */ "/vercel/path0/src/containers/GalleryContainer/GalleryContainer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/utils/styles.scss");
